/**
 * Login welcome toast is for returning users only.
 * First-time users (onboarding incomplete) go straight to onboarding without a toast overlay.
 */
export function shouldShowLoginWelcomeToast(onboardingComplete: boolean | undefined): boolean {
  return onboardingComplete === true;
}
